import { DEFAULT_DISPLAY_FIELDS } from '@iconik-io/shared-lib/src/constants/search';
import type { CommonListAppState } from '@iconik-io/shared-lib/src/redux/common_list/types';
import { getQueryPage } from '@iconik-io/shared-lib/src/utils/url/get_query_page';
import { getQueryPerPage } from '@iconik-io/shared-lib/src/utils/url/get_query_per_page';

import { PAGE_SIZE_ITEM } from '../../../constants/local_storage';
import type { SearchViewAppState } from './types';

export const initialSearchListState: CommonListAppState = {
  ids: [],
  page: getQueryPage(window.location.search),
  perPage: getQueryPerPage(window.location.search, PAGE_SIZE_ITEM),
  pagination: {
    page: getQueryPage(window.location.search),
    pages: 0,
    total: 0,
    per_page: getQueryPerPage(window.location.search, PAGE_SIZE_ITEM),
  },
  sort: [
    {
      name: 'date_created',
      order: 'desc',
    },
  ],
  isLoading: false,
  status: 'pending',
  fetchStatus: 'idle',
};

export const initialSearchViewState: SearchViewAppState = {
  activeViewId: undefined,
  currentDisplayFields: DEFAULT_DISPLAY_FIELDS,
};
